// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G9o0","toggleWrap":"styles_toggleWrap__3chuB","content":"styles_content__2N29E","selectAreaCode":"styles_selectAreaCode__nE6fn"};